import React, { useEffect, useState, useRef } from 'react';
import { Row, Col, DatePicker, Select, Radio, message } from 'antd';
// import Loading from "../../components/Loading";
import { useForm, Controller } from 'react-hook-form';
import moment from 'moment';
// import { useCookies } from "react-cookie";
import useApplicationSession from '../../session/UserSession';
// import { useHistory } from "react-router-dom";
import YFinput from '../elements/YFInput';
import YFTextArea from '../elements/YFTextArea';
import { countries, getStateOfCountry } from '../../utils/countries';
// import {
//   state_number,
//   nationality as nrc_nationality,
//   getDistrict,
// } from "../../utils/nrc";
import { createProfile } from '../../api';
// import { useApiCall } from "../../api/apiCallHook";
// import YFInput from "../elements/YFInput";
// import { useCallback } from "react";
import { UserOutlined, HomeOutlined } from '@ant-design/icons';
import profileStore from './profileStore';

const { Option } = Select;

const ProfileForm = ({ user }) => {
    const token = useApplicationSession();
    const { control, register, handleSubmit, setValue, setError, errors, clearError } = useForm();

    const [stateOfCountry, setSateOfCountry] = useState([]);
    const inputRef = useRef();
    const onSubmit = (data) => {
        data.date_of_birth = data.date_of_birth?.format('DD-MM-YYYY');
        data.address_line_two = data?.previous_address;
        const hide = message.loading('Loading ...');
        createProfile({ token, request: data })
            .then((response) => {
                hide();
                message.success(response?.data?.message);
                profileStore.reload(token);
            })
            .catch((error) => {
                hide();
            });
    };

    useEffect(() => {
        const value = user?.profile ?? {};
        value.email = user?.email;
        value.first_name = user?.first_name;
        value.last_name = user?.last_name;
        value.address_line_two = user?.previous_address;
        if (value !== null) {
            const values = [];
            const keys = Object.keys(value);
            keys.forEach((key) => {
                if (key === 'date_of_birth') {
                    values.push({
                        [key]: value[key] === '' ? '' : moment(value[key], 'DD-MM-YYYY'),
                    });
                } else {
                    values.push({ [key]: value[key] });
                }
            });
            setValue(values);
        }
    }, [setValue, user]);

    return (
        <>
            <form onSubmit={handleSubmit(onSubmit)} className="payment-information-form">
                {/* -------- Personal information section -------- */}
                <div className="payment-information-label-container">
                    <UserOutlined className="personal-information-icon" style={{ fontSize: 20, padding: 10 }} />
                    <h4 className="payment-information-label">
                        Personal Information
                        <span className="personalEmailLabel">
                            <YFinput
                                disabled={false}
                                name="email"
                                register={register({
                                    required: true,
                                    pattern:
                                        /^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                                })}
                            />
                        </span>
                    </h4>
                </div>
                <Row className="horizontal-container">
                    <Col
                        xs={{ span: 24 }}
                        sm={{ span: 24 }}
                        md={{ span: 12 }}
                        lg={{ span: 12 }}
                        xl={{ span: 12 }}
                        xxl={{ span: 12 }}
                        className="horizontal-container-element"
                    >
                        <YFinput
                            test_id="subscription-information-first-name"
                            name="first_name"
                            type="text"
                            label="First Name"
                            placeholder="Enter First Name"
                            register={register({ required: true })}
                        />
                        <div className="form-error">
                            {errors.first_name && (
                                <span className="formFieldError"> Please enter your first name. </span>
                            )}
                        </div>
                    </Col>
                    <Col
                        xs={{ span: 24 }}
                        sm={{ span: 24 }}
                        md={{ span: 12 }}
                        lg={{ span: 12 }}
                        xl={{ span: 12 }}
                        xxl={{ span: 12 }}
                        className="horizontal-container-element"
                    >
                        <YFinput
                            test_id="subscription-information-last-name"
                            name="last_name"
                            type="text"
                            label="Last Name"
                            placeholder="Enter Last Name"
                            register={register({ required: true })}
                        />
                        <div className="form-error">
                            {errors.last_name && <span className="formFieldError">Please enter your last name.</span>}
                            {/* (<Alert type="error" message="Last Naame Required." />) */}
                        </div>
                    </Col>
                </Row>
                <Row className="horizontal-container">
                    <Col
                        xs={{ span: 24 }}
                        sm={{ span: 24 }}
                        md={{ span: 12 }}
                        lg={{ span: 12 }}
                        xl={{ span: 12 }}
                        xxl={{ span: 12 }}
                        className="horizontal-container-element"
                    >
                        <label>Date of Birth</label>
                        <Controller
                            as={
                                <DatePicker
                                    test_id="subscription-information-date-of-birth"
                                    name="date_of_birth"
                                    ref={inputRef}
                                    format={'DD-MM-YYYY'}
                                    inputReadOnly
                                />
                            }
                            control={control}
                            name="date_of_birth"
                            rules={{ required: true }}
                            onChange={([date]) => {
                                const duration = moment.duration(moment().diff(date));
                                const diff = duration.asYears();
                                if (diff < 18) {
                                    setError('date_of_birth', 'notMatch', 'Age must be greater than 18.');
                                    return;
                                } else {
                                    clearError('date_of_birth');
                                }
                                return date;
                            }}
                        />
                        <div className="form-error">
                            {errors.date_of_birth?.type === 'required' && (
                                <span className="formFieldError"> Please select your date of birth. </span>
                            )}
                            {errors.date_of_birth?.type === 'notMatch' && (
                                <span className="formFieldError"> {errors.date_of_birth?.message} </span>
                            )}
                        </div>
                    </Col>
                    <Col
                        xs={{ span: 24 }}
                        sm={{ span: 24 }}
                        md={{ span: 12 }}
                        lg={{ span: 12 }}
                        xl={{ span: 12 }}
                        xxl={{ span: 12 }}
                        className="horizontal-container-element"
                    >
                        <YFinput
                            test_id="subscription-information-office-email"
                            name="office_email"
                            type="email"
                            label="Work Email"
                            placeholder="Enter work email"
                            register={register({
                                required: true,
                                pattern:
                                    /^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                            })}
                        />
                        <div className="form-error">
                            {errors.office_email?.type === 'required' && (
                                <span className="formFieldError">Please enter your contact number.</span>
                            )}
                            {errors.office_email?.type === 'pattern' && (
                                <span className="formFieldError">Please enter valid email format.</span>
                            )}
                        </div>
                    </Col>
                </Row>
                <Row className="horizontal-container">
                    <Col
                        xs={{ span: 24 }}
                        sm={{ span: 24 }}
                        md={{ span: 12 }}
                        lg={{ span: 12 }}
                        xl={{ span: 12 }}
                        xxl={{ span: 12 }}
                        className="horizontal-container-element"
                    >
                        <YFinput
                            test_id="subscription-information-contact-number"
                            name="contact_number"
                            type="number"
                            label="Persoanl Phone"
                            placeholder="Enter Phone (Personal)"
                            register={register({
                                required: true,
                                minLength: {
                                    value: 5,
                                    message: 'Phone number length must be 5 digit.',
                                },
                                maxLength: {
                                    value: 11,
                                    message: 'Phone number length maximun 11 digit.',
                                },
                            })}
                        />
                        <div className="form-error">
                            {errors.contact_number?.type === 'required' && (
                                <span className="formFieldError">Please enter your contact number.</span>
                            )}
                            {errors.contact_number?.type === 'minLength' && (
                                <span className="formFieldError">{errors.contact_number?.message}</span>
                            )}
                            {errors.contact_number?.type === 'maxLength' && (
                                <span className="formFieldError">{errors.contact_number?.message}</span>
                            )}
                            {/* (<Alert type="error" message="Content Number Required." />) */}
                        </div>
                    </Col>
                    <Col
                        xs={{ span: 24 }}
                        sm={{ span: 24 }}
                        md={{ span: 12 }}
                        lg={{ span: 12 }}
                        xl={{ span: 12 }}
                        xxl={{ span: 12 }}
                        className="horizontal-container-element"
                    >
                        <YFinput
                            test_id="subscription-information-office-contact-number"
                            name="office_contact_number"
                            type="number"
                            label="Work Phone"
                            placeholder="Enter Work Phone"
                            register={register({
                                required: true,
                                minLength: {
                                    value: 5,
                                    message: 'Phone number length must be 5 digit.',
                                },
                                maxLength: {
                                    value: 11,
                                    message: 'Phone number length maximun 11 digit.',
                                },
                            })}
                        />
                        <div className="form-error">
                            {errors.office_contact_number?.type === 'required' && (
                                <span className="formFieldError">Please enter your contact number.</span>
                            )}
                            {errors.office_contact_number?.type === 'minLength' && (
                                <span className="formFieldError">{errors.contact_number?.message}</span>
                            )}
                            {errors.office_contact_number?.type === 'maxLength' && (
                                <span className="formFieldError">{errors.contact_number?.message}</span>
                            )}
                        </div>
                    </Col>
                </Row>
                <Row className="horizontal-container">
                    <Col
                        xs={{ span: 24 }}
                        sm={{ span: 24 }}
                        md={{ span: 12 }}
                        lg={{ span: 12 }}
                        xl={{ span: 12 }}
                        xxl={{ span: 12 }}
                        className="horizontal-container-element"
                    >
                        <label htmlFor="martial_status">Martial status</label>
                        <Controller
                            name="martial_status"
                            as={
                                <Select
                                    id="subscription-information-martial-status"
                                    showSearch
                                    className="yf-select"
                                    style={{ width: '100%' }}
                                    placeholder="Select Matrial Status"
                                    ref={inputRef}
                                    optionFilterProp="children"
                                    filterOption={(input, option) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }
                                >
                                    {martialStatus.map((item) => {
                                        return (
                                            <Option value={item.value} key={item.id}>
                                                {item.label}
                                            </Option>
                                        );
                                    })}
                                </Select>
                            }
                            onChange={([selected]) => {
                                return selected;
                            }}
                            rules={{ required: true }}
                            control={control}
                        />
                        {errors.martial_status?.type === 'required' && (
                            <span className="formFieldError">Please select martial status.</span>
                        )}
                    </Col>
                    <Col
                        xs={{ span: 24 }}
                        sm={{ span: 24 }}
                        md={{ span: 12 }}
                        lg={{ span: 12 }}
                        xl={{ span: 12 }}
                        xxl={{ span: 12 }}
                        className="horizontal-container-element"
                    >
                        <YFinput
                            test_id="subscription-information-no-of-dependent"
                            name="no_of_dependent"
                            type="number"
                            label="Number of dependents"
                            placeholder="Enter nunber of dependents"
                            register={register({
                                required: true,
                                minLength: {
                                    value: 1,
                                    message: 'Phone number length must be 1 digit',
                                },
                            })}
                        />
                        <div className="form-error">
                            {errors.no_of_dependent?.type === 'required' && (
                                <span className="formFieldError">Please enter your dependents family members.</span>
                            )}
                            {errors.no_of_dependent?.type === 'minLength' && (
                                <span className="formFieldError">{errors.contact_number?.message}</span>
                            )}
                        </div>
                    </Col>
                </Row>
                {/* -------- personal information section end -------- */}
                {/* -------- Address information section -------- */}
                <div className="payment-information-label-container">
                    <HomeOutlined className="personal-information-icon" style={{ fontSize: 20, padding: 10 }} />
                    <h4 className="payment-information-label">Address Information</h4>
                </div>
                <Row className="horizontal-container">
                    <Col
                        xs={{ span: 24 }}
                        sm={{ span: 24 }}
                        md={{ span: 24 }}
                        lg={{ span: 24 }}
                        xl={{ span: 24 }}
                        xxl={{ span: 24 }}
                        className="horizontal-container"
                    >
                        <YFTextArea
                            test_id="subscription-information-address"
                            name="address"
                            type="text"
                            label="Address"
                            placeholder="Enter Address"
                            rows={8}
                            register={register({ required: true })}
                        />
                        {errors.address && <span className="formFieldError">Please enter your address.</span>}
                    </Col>
                </Row>
                <Row className="horizontal-container">
                    <Col
                        xs={{ span: 24 }}
                        sm={{ span: 24 }}
                        md={{ span: 24 }}
                        lg={{ span: 24 }}
                        xl={{ span: 24 }}
                        xxl={{ span: 24 }}
                        className="horizontal-container"
                    >
                        <Controller
                            name="property"
                            as={
                                <Radio.Group>
                                    <Radio value="OWN_HOME_OUTRIGHT">Own Home Outright</Radio>
                                    <Radio id="subscription-information-property" value="RENTING">
                                        Renting
                                    </Radio>
                                    <Radio value="LIVING_WITH_FAMILY">Living with family</Radio>
                                </Radio.Group>
                            }
                            control={control}
                            onChange={([event]) => {
                                return event.target.value;
                            }}
                            rules={{ required: true }}
                        />
                        {errors?.property?.type === 'required' && (
                            <span className="formFieldError">Please select your property type.</span>
                        )}
                    </Col>
                </Row>
                <Row className="horizontal-container">
                    <Col
                        xs={{ span: 24 }}
                        sm={{ span: 24 }}
                        md={{ span: 24 }}
                        lg={{ span: 24 }}
                        xl={{ span: 24 }}
                        xxl={{ span: 24 }}
                        className="horizontal-container"
                    >
                        <YFinput
                            test_id="subscription-information-time-at-address"
                            name="time_at_address"
                            type="text"
                            label="Duration"
                            placeholder="Enter duration"
                            register={register({ required: true })}
                        />
                        {errors.time_at_address && (
                            <span className="formFieldError">Please enter how long you live at this address.</span>
                        )}
                    </Col>
                </Row>
                <Row className="horizontal-container">
                    <Col
                        xs={{ span: 24 }}
                        sm={{ span: 24 }}
                        md={{ span: 12 }}
                        lg={{ span: 12 }}
                        xl={{ span: 12 }}
                        xxl={{ span: 12 }}
                        className="horizontal-container-element"
                    >
                        <label htmlFor="country">Country</label>
                        <Controller
                            name="country"
                            as={
                                <Select
                                    id="subscription-information-country"
                                    showSearch
                                    className="yf-select"
                                    style={{ width: '100%' }}
                                    placeholder="Select Country"
                                    ref={inputRef}
                                    optionFilterProp="children"
                                    filterOption={(input, option) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }
                                >
                                    {countries.map((item) => {
                                        return (
                                            <Option value={item.value} key={item.value}>
                                                {item.label}
                                            </Option>
                                        );
                                    })}
                                </Select>
                            }
                            onChange={([selected]) => {
                                setSateOfCountry(getStateOfCountry(selected));
                                setValue('state', undefined);
                                return selected;
                            }}
                            rules={{ required: true }}
                            control={control}
                        />
                        <div className="form-error">
                            {errors.country && <span className="formFieldError"> Please select your country. </span>}
                        </div>
                    </Col>
                    <Col
                        xs={{ span: 24 }}
                        sm={{ span: 24 }}
                        md={{ span: 12 }}
                        lg={{ span: 12 }}
                        xl={{ span: 12 }}
                        xxl={{ span: 12 }}
                        className="horizontal-container-element"
                    >
                        <label htmlFor="state">State</label>
                        <Controller
                            name="state"
                            as={
                                <Select
                                    id="subscription-information-state"
                                    showSearch
                                    className="yf-select"
                                    style={{ width: '100%' }}
                                    placeholder="Select State"
                                    ref={inputRef}
                                    optionFilterProp="children"
                                    filterOption={(input, option) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }
                                >
                                    {stateOfCountry.map((item) => {
                                        return (
                                            <Option value={item.value} key={item.id}>
                                                {item.label}
                                            </Option>
                                        );
                                    })}
                                </Select>
                            }
                            onChange={([selected]) => {
                                return selected;
                            }}
                            rules={{ required: true }}
                            control={control}
                        />
                        <div className="form-error">
                            {errors.state && <span className="formFieldError"> Please select your state. </span>}
                        </div>
                    </Col>
                </Row>
                <Row className="horizontal-container">
                    <Col
                        xs={{ span: 24 }}
                        sm={{ span: 24 }}
                        md={{ span: 12 }}
                        lg={{ span: 12 }}
                        xl={{ span: 12 }}
                        xxl={{ span: 12 }}
                        className="horizontal-container-element"
                    >
                        <YFinput
                            test_id="subscription-information-city"
                            name="city"
                            type="text"
                            label="City"
                            placeholder="Enter City"
                            register={register({ required: true })}
                        />
                        <div className="form-error">
                            {errors.city && <span className="formFieldError"> Please enter your city. </span>}
                        </div>
                    </Col>
                    <Col
                        xs={{ span: 24 }}
                        sm={{ span: 24 }}
                        md={{ span: 12 }}
                        lg={{ span: 12 }}
                        xl={{ span: 12 }}
                        xxl={{ span: 12 }}
                        className="horizontal-container-element"
                    >
                        <YFinput
                            test_id="subscription-information-post-code"
                            name="post_code"
                            type="number"
                            label="Postal Code"
                            placeholder="Enter Postal Code"
                            register={register({ required: true })}
                        />
                        <div className="form-error">
                            {errors.post_code && (
                                <span className="formFieldError"> Please enter your postal code. </span>
                            )}
                        </div>
                    </Col>
                </Row>
                <Row className="horizontal-container">
                    <Col
                        xs={{ span: 24 }}
                        sm={{ span: 24 }}
                        md={{ span: 24 }}
                        lg={{ span: 24 }}
                        xl={{ span: 24 }}
                        xxl={{ span: 24 }}
                        className="horizontal-container"
                    >
                        <YFTextArea
                            test_id="subscription-information-address-line-two"
                            name="previous_address"
                            type="text"
                            label="Previous Address (If less than 2 years)"
                            placeholder="Enter Previous Address"
                            rows={8}
                            register={register({ required: false })}
                        />
                    </Col>
                </Row>
                {/* -------- Address information section end-------- */}
                {/* -------- Button section -------- */}
                <Row className="horizontal-container">
                    <Col
                        xs={{ span: 24 }}
                        sm={{ span: 24 }}
                        md={{ span: 8, offset: 16 }}
                        lg={{ span: 8, offset: 16 }}
                        xl={{ span: 8, offset: 16 }}
                        xxl={{ span: 8, offset: 16 }}
                        className="horizontal-container-element"
                    >
                        <input
                            test_id="subscription-information-submit"
                            className="profileEdit"
                            type="submit"
                            value="Save"
                        />
                    </Col>
                </Row>
                {/* --------  Button section end -------- */}
            </form>
        </>
    );
};

const martialStatus = [
    {
        id: '1',
        label: 'Single',
        value: 'Single',
    },
    {
        id: '2',
        label: 'Married',
        value: 'Married',
    },
];

export default ProfileForm;
